import React from 'react';
import { FormInputNew } from 'components/Input/FormInputNew';

interface IProps {
	setMixpanelToken: (value: string) => void;
}

export const MixpanelTokenField: React.FC<IProps> = React.memo(({ setMixpanelToken }) => {
	return (
		<FormInputNew
			testId="MixpanelTokenField"
			name="mixpanelToken"
			label="mixpanelTokenLabel"
			placeholder="mixpanelTokenPlaceholder"
			onChange={setMixpanelToken}
		/>
	);
});
